import React from "react";
import "../Aboutus/Abteam.css";
import { Link } from "react-router-dom";
const teamMembers = [
  { name: "Adv. Rajesh Sharma", title: "Managing Partner", image: "demo.webp" },
  { name: "Adv. Priya Kapoor", title: "Senior Partner", image: "demo2.webp" },
  { name: "Adv. Anil Mehta", title: "Partner", image: "demo.webp" },
  { name: "Adv. Sneha Iyer", title: "Partner", image: "demo2.webp" },
  { name: "Adv. Vikram Singh", title: "Associate Partner", image: "demo.webp" },
  { name: "Adv. Nisha Patel", title: "Associate Partner", image: "demo2.webp" },
];

const chunkIntoColumns = (array, columnCount) => {
  const columns = Array.from({ length: columnCount }, () => []);
  array.forEach((item, index) => {
    columns[index % columnCount].push(item);
  });
  return columns;
};

const Abteam = () => {
  const columns = chunkIntoColumns(teamMembers, 3);

  return (
    <div className="abteam-container-abb">
      <div className="abteam-left-abb">
        <p className="section-label-abb">TEAM MEMBER</p>
        <h1>Our Experienced Legal Experts</h1>
        <p className="description-abb">
          To explore and go after new ways to defend and advocate, we’ve
          gathered skilled lawyers and innovative minds to solve even the
          toughest legal challenges.
        </p>
        <Link to="/contactus">
          <button className="contact-button-abb">Contact Us</button>
        </Link>
      </div>

      <div className="abteam-right-abb">
        {columns.map((column, colIndex) => (
          <div
            className={`team-column-abb column-${colIndex}-abb`}
            key={colIndex}
          >
            {column.map((member, index) => (
              <div className="team-card-abb" key={index}>
                <div className="card-image-abb">
                  <img src={member.image} alt={member.name} />
                </div>
                <h3>{member.name}</h3>
                <p>{member.title}</p>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Abteam;
